import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useNavigate } from "react-router-dom";
import icon from "../assets/ic_maxicare.png";
import PropTypes from "prop-types";
import {
  BottomNavigationAction,
  BottomNavigation,
  ListItemButton,
  ThemeProvider,
  ListItemIcon,
  ListItemText,
  createTheme,
  Toolbar,
  Drawer,
  AppBar,
  List,
  Box,
} from "@mui/material";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1280,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: "Lato",
    body1: {
      fontWeight: 600,
      color: "#60656D",
    },
  },
});

export const SideDrawer = (props) => {
  const navigate = useNavigate();
  const drawerWidth = 240;

  return (
    <div className="flex flex-col items-center min-h-screen max-w-screen sm:bg-[#E7EEFA] lg:pl-[240px] cursor-default">
      <Box
        component="nav"
        sx={{
          width: { md: `calc(100% - ${drawerWidth}` },
          flexShrink: { md: 0 },
        }}
      >
        <ThemeProvider theme={theme}>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "none", md: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
            open
          >
            <div>
              <Toolbar>
                <img src={icon} alt="Bell" />
              </Toolbar>

              <List>
                <ListItemButton
                  selected={window.location.pathname === "/home"}
                  onClick={() => navigate("/home")}
                >
                  <ListItemIcon>
                    <HomeOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Home" />
                </ListItemButton>

                <ListItemButton
                  selected={window.location.pathname === "/add-policy"}
                  onClick={() => navigate("/add-policy")}
                >
                  <ListItemIcon>
                    <CreditCardOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Policies" />
                </ListItemButton>

                <ListItemButton
                  selected={window.location.pathname === "/book-service"}
                  onClick={() => navigate("/book-service")}
                >
                  <ListItemIcon>
                    <CalendarTodayIcon />
                  </ListItemIcon>
                  <ListItemText primary="Book" />
                </ListItemButton>

                <ListItemButton
                  selected={window.location.pathname === "/transaction-history"}
                  onClick={() => navigate("/transaction-history")}
                >
                  <ListItemIcon>
                    <RestoreOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="History" />
                </ListItemButton>

                <ListItemButton
                  selected={window.location.pathname === "/my-account"}
                  onClick={() => navigate("/my-account")}
                >
                  <ListItemIcon>
                    <PersonOutlineOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Account" />
                </ListItemButton>
              </List>
            </div>
          </Drawer>
        </ThemeProvider>
        {props.children}
      </Box>
    </div>
  );
};

SideDrawer.propTypes = {
  children: PropTypes.node.isRequired,
};

export const BottomNavBar = () => {
  const navigate = useNavigate();
  return (
    <ThemeProvider theme={theme}>
      <AppBar
        position="fixed"
        color="primary"
        sx={{
          display: { sm: "block", md: "none" },
          top: "auto",
          bottom: 0,
        }}
      >
        <BottomNavigation
          showLabels
          value={window.location.pathname}
          onChange={(event, newValue) => {
            navigate(newValue);
          }}
        >
          <BottomNavigationAction
            label="Home"
            icon={<HomeOutlinedIcon />}
            sx={{ minWidth: 0 }}
            value={"/home"}
          />
          <BottomNavigationAction
            label="Policies"
            icon={<CreditCardOutlinedIcon />}
            sx={{ minWidth: 0 }}
            value={"/add-policy"}
          />
          <BottomNavigationAction
            label="Book"
            icon={<CalendarTodayIcon />}
            sx={{ minWidth: 0 }}
            value={"/book-service"}
          />
          <BottomNavigationAction
            label="History"
            icon={<RestoreOutlinedIcon />}
            sx={{ minWidth: 0 }}
            value={"/transaction-history"}
          />
          <BottomNavigationAction
            label="Account"
            icon={<PersonOutlineOutlinedIcon />}
            sx={{ minWidth: 0 }}
            value={"/my-account"}
          />
        </BottomNavigation>
      </AppBar>
    </ThemeProvider>
  );
};
